import type { DefaultValues } from 'react-hook-form';
import { useParams, useSearchParams } from 'react-router-dom';

import type { IInvitationResponseFormValues } from '~/components/forms/InvitationResponseForm';
import { InvitationPage } from '~/components/pages/InvitationPage';
import { PageTemplate } from '~/components/templates/PageTemplate';
import { Navigate } from '~/components/utils/Navigation';

export const InvitationRoute: React.FC = () => {
  const { invitationId } = useParams();
  const [searchParams] = useSearchParams();
  const defaultValues: DefaultValues<IInvitationResponseFormValues> = {
    challengeCode: searchParams.get('challengeCode') || undefined,
  };

  if (!invitationId) {
    return <Navigate to="/" replace />;
  }

  return (
    <PageTemplate>
      <InvitationPage
        invitationId={invitationId}
        defaultValues={defaultValues}
      />
    </PageTemplate>
  );
};
